import { patientList, patientAdd, patientEdit, patientDelete, getDoctorVisitApi, patientInfom, getCaseDiagnosis, getCaseFieldAllApi, getCaseFieldApi, editCaseFieldApi, restoreCaseFieldApi } from '@/api/patient'
import { addressAdd, addressList, addressEdit, deleteDelivery } from '@/api/address'
import { editCaseDiagnosisApi } from "@/api/outpatientDetail.js";

class patientDTO {
    /**
     * 获取患者列表
     * params 分页信息等
     */
    static getPatientList(params) {
        return new Promise((resolve, reject) => {
            patientList(params).then(res => {
                resolve(res)
            })
        })
    }

    /**
     * 新增患者
     * params 患者基本信息
     */
    static patientAdd(params) {
        return new Promise((resolve, reject) => {
            patientAdd(params).then(res => {
                resolve(res)
            })
        })
    }

    /**
     * 修改患者信息
     * params 患者基本信息
     */
    static patientEdit(params) {
        return new Promise((resolve, reject) => {
            patientEdit(params).then(res => {
                resolve(res)
            })
        })
    }

    /**
     * 删除患者信息
     * patientIds 患者id
     */
    static patientDelete(patientIds) {
        return new Promise((resolve, reject) => {
            patientDelete(patientIds).then(res => {
                resolve(res)
            })
        })
    }

    /**
     * 查询患者是否为新诊
     * params 患者id、医生id
     */
    static getDoctorVisit(params) {
        return new Promise((resolve, reject) => {
            getDoctorVisitApi(params).then(res => {
                resolve(res)
            })
        })
    }

    /**
     * 新增患者收获地址
     * params 患者id、收货地址信息
     */
    static addressAdd(params) {
            return new Promise((resolve, reject) => {
                addressAdd(params).then(res => {
                    resolve(res)
                })
            })
        }
        /**
         * 修改患者收获地址
         * params 患者id、收货地址信息
         */
    static addressEdit(params) {
            return new Promise((resolve, reject) => {
                addressEdit(params).then(res => {
                    resolve(res)
                })
            })
        }
        /**
         * 修改患者收获地址
         * params 收货地址id
         */
    static addressDelete(id) {
        return new Promise((resolve, reject) => {
            deleteDelivery(id).then(res => {
                resolve(res)
            })
        })
    }

    /**
     * 根据患者id查询收货地址 
     * patientId 患者id
     */
    static addressList(patientId) {
        return new Promise((resolve, reject) => {
            addressList(patientId).then(res => {
                resolve(res)
            })
        })
    }

    /**
     * 通过电话号码和姓名获取患者信息
     * params 电话号码、患者姓名等患者基本信息
     */
    static patientInfom(params) {
            return new Promise((resolve, reject) => {
                patientInfom(params).then(res => {
                    resolve(res)
                })
            })
        }
        /**
         * 编辑患者病历
         * obj 就诊id
         */
    static editCaseDiagnosis(obj) {
            return new Promise((resolve, reject) => {
                editCaseDiagnosisApi(obj).then(res => {
                    resolve(res)
                })
            })
        }
        /**
         * 查询患者病历
         * obj 就诊id
         */
    static getCaseDiagnosis(obj) {
            return new Promise((resolve, reject) => {
                getCaseDiagnosis(obj).then(res => {
                    resolve(res)
                })
            })
        }
        /**
         * 获取所有的病例字段
         */
    static getCaseFieldAll(obj) {
            return new Promise((resolve, reject) => {
                getCaseFieldAllApi(obj).then(res => {
                    resolve(res)
                })
            })
        }
        /**
         * 获取当前登录人设置病例字段
         */
    static getCaseField(obj) {
            return new Promise((resolve, reject) => {
                getCaseFieldApi(obj).then(res => {
                    resolve(res)
                })
            })
        }
        /**
         * 编辑当前登录人病例字段
         */
    static editCaseField(obj) {
            return new Promise((resolve, reject) => {
                editCaseFieldApi(obj).then(res => {
                    resolve(res)
                })
            })
        }
        /**
         * 恢复当前登录人病例字段
         */
    static restoreCaseField(obj) {
        return new Promise((resolve, reject) => {
            restoreCaseFieldApi(obj).then(res => {
                resolve(res)
            })
        })
    }
}

export { patientDTO }